export const achievementData = {
    bio : "",
    achievements : [  /*
        {
           
            id : 1,
            title : '2021 Complete Python Bootcamp From Zero to Hero in Python',
            details : 'A python course from Udemy',
            date : 'Jan 28, 2021',
            field : 'Coding',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-0cd075aa-f55b-4d9f-aec0-119020a4e792.jpg?v=1611846350000'
        },
        {
            id : 2,
            title : '',
            details : '',
            date : '',
            field : '',
            image : ''
        },
        {
            id : 3,
            title : '',
            details : '',
            date : '',
            field : '',
            image : ''
        },
        {
            id : 3,
            title : '',
            details : '',
            date : '',
            field : '',
            image : ''
        } */

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

Ej
{
            id : 1,
            title : '2021 Complete Python Bootcamp From Zero to Hero in Python',
            details : 'A python course from Udemy',
            date : 'Jan 28, 2021',
            field : 'Coding',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-0cd075aa-f55b-4d9f-aec0-119020a4e792.jpg?v=1611846350000'
        },

*/